import {Directive, inject, input, TemplateRef} from '@angular/core';

export type SelectionTableCellContext<T> = {
    $implicit: T;
};

@Directive({
    selector: 'ng-template[appSelectionTableCell]',
    standalone: true,
})
export class SelectionTableCellDirective<T> {
    readonly appSelectionTableCell = input.required<string>();
    readonly appSelectionTableCellOf = input.required<ReadonlyArray<T>>();

    readonly template = inject<TemplateRef<SelectionTableCellContext<T>>>(TemplateRef);

    static ngTemplateContextGuard<T>(
        _: SelectionTableCellDirective<T>,
        context: unknown,
    ): context is SelectionTableCellContext<T> {
        return typeof context === 'object' && context !== null && '$implicit' in context;
    }
}

@Directive({
    selector: 'ng-template[appSelectionTableFilter]',
    standalone: true,
})
export class SelectionTableFilterDirective {
    readonly appSelectionTableFilter = input.required<string>();

    readonly template = inject<TemplateRef<void>>(TemplateRef);
}
